export default "__VITE_PUBLIC_ASSET__62f441ac__"